// Sincronización de catálogos y fichas con el API (funciones puras, con test).

// Catálogos gestionados en dbo.Obras_Catalogos (persisten vía API). El resto de
// "catálogos" del front (pais/ciudad -> geografía, proveedores -> Empresas,
// solZonif -> bit, Sí/No fijo) no viven en esa tabla y se mantienen en local.
export const DB_CATALOG_TYPES = new Set([
    "tipo", "campana", "estado", "zona_comercial",
    "imagen", "imgOriginal", "ilumGral",
    "provSuelo", "tipoSuelo", "liquidacion",
]);

// Filas de GET /api/obras/catalogos -> catálogos de la ficha y empresas (proveedores).
// Todos los tipos de BD se sustituyen por lo que devuelve el API (vacío incluido), para
// no arrastrar valores mock en la ruta real. Los proveedores (dbo.Empresas) llegan como
// tipo 'empresa': no son un catálogo de la ficha, pero dan su CodEmpresa a cada rol.
export function catalogStateFromRows(rows) {
    const byTipo = {};
    DB_CATALOG_TYPES.forEach((tipo) => { byTipo[tipo] = []; });
    const empresas = [];
    // Studios: empresas de tipo 4 (estudios), el catálogo tal cual lo devuelve el API.
    const studios = [];
    rows.forEach((row) => {
        if (row.tipo === "empresa") {
            empresas.push({ id: Number(row.codCatalogo), value: row.valor });
            return;
        }
        if (row.tipo === "studio") {
            studios.push({ id: Number(row.codCatalogo), value: row.valor, parent: null, active: true });
            return;
        }
        if (!DB_CATALOG_TYPES.has(row.tipo)) return;
        byTipo[row.tipo].push({
            id: Number(row.codCatalogo),
            value: row.valor,
            parent: null,
            active: row.activo === true || row.activo === 1,
        });
    });
    if (studios.length) byTipo.studio = studios;
    return { byTipo, empresas };
}

// ¿Trae la ficha fresca algún dato distinto del que se tiene? Renombrar un catálogo o un
// proveedor cambia el nombre que devuelve la ficha sin tocar el RowVersion de la obra,
// así que el sondeo no puede fiarse solo de la versión. Se comparan los valores simples
// (las agrupaciones del front, arrays, se derivan de ellos; los campos _internos no cuentan).
export function apiRowChanged(current, fresh) {
    return Object.keys(fresh).some((key) => {
        if (key.startsWith("_")) return false;
        const value = fresh[key];
        if (value !== null && typeof value === "object") return false;
        return String(value ?? "") !== String(current?.[key] ?? "");
    });
}

// Catálogos que admiten «+ Añadir nuevo» en el desplegable. No lo admiten:
// - país y ubicación: los países son una lista cerrada y una ubicación nueva necesita su
//   región, así que se da de alta en el panel del engranaje (catálogo geográfico);
// - estado: las alertas, el riesgo y "completada" dependen de sus valores exactos (en DES
//   llegó a crearse un estado «aaa»). El API tampoco deja renombrarlos.
const NO_INLINE_CREATE = new Set(["pais", "ciudad", "estado", "zona_comercial"]);
export const catalogAllowsInlineCreate = (catalog) => !NO_INLINE_CREATE.has(catalog);

// Catálogos cuyo valor se puede quitar (dejar vacío) desde el desplegable. El estado no:
// toda obra tiene uno y la lógica de riesgo y avisos depende de él.
export const catalogAllowsClear = (catalog) => catalog !== "estado";
